import { render, staticRenderFns } from "./board-view.vue?vue&type=template&id=84a9312e&"
import script from "./board-view.vue?vue&type=script&lang=js&"
export * from "./board-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports